import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ArrowLeft } from "lucide-react";
import { Helmet } from "react-helmet-async";

function NotFound() {
  <Helmet>
    <title>404 - Page Not Found | Web X Secure</title>

    <meta name="robots" content="noindex, nofollow" />
  </Helmet>;
  return (
    <section className="min-h-screen flex items-center justify-center bg-[#f8f8f8] dark:bg-[#050505] px-6">
      <div className="text-center max-w-xl">
        <div className="flex justify-center mb-6">
          <AlertTriangle className="w-20 h-20 text-primary" />
        </div>

        <h1 className="text-7xl font-black text-primary mb-4">404</h1>

        <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
          Page Not Found
        </h2>

        <p className="text-gray-600 dark:text-gray-400 mb-8">
          Sorry, the page you are looking for does not exist or may have been
          moved.
        </p>

        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-lg bg-primary px-6 py-3 text-white font-semibold"
        >
          <ArrowLeft size={18} />
          Back To Home
        </Link>
      </div>
    </section>
  );
}

export default NotFound;
